import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { countAdjacentRepeatedLetterGroups } from '../wordAnalysis'

export const doubleDoubleCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return isAcceptedWordEntry(entry) && countAdjacentRepeatedLetterGroups(entry.word) >= 2
}
